"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var ExclamationCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "clip-rule": "evenodd", "d": "M1 12a11 11 0 1122 0 11 11 0 01-22 0zm12-4a1 1 0 10-2 0v4a1 1 0 102 0V8zm-1 7a1 1 0 100 2h.01a1 1 0 100-2H12z", "fill-rule": "evenodd" } }] }, "name": "exclamation-circle", "theme": "filled" };
exports.default = ExclamationCircleFilled;
